.panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 12px;
  overflow-y: auto;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background-color: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.item:hover {
  background-color: var(--color-bg-hover);
  border-color: var(--color-primary);
}

.item:active {
  background-color: var(--color-primary-alpha-20);
}

.label {
  margin-top: 8px;
  font-size: 11px;
  text-align: center;
  color: var(--color-text);
}
